module.exports = __webpack_public_path__ + "assets/bdceafecb554d2a98e2e075d30268e24.mp3";